import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Performance Max on the YouTube watch page (mobile): square image ad under
 * the player, with a CTA bar and headline, description and Sponsored line
 * below.
 */
@Component({
    selector: 'app-pmax-youtube-mobile-02',
    imports: [
        CommonModule,
        MobileFrameComponent,
    ],
    templateUrl: './youtube-mobile-02.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-mobile-02.component.scss',
    ]
})
export class PmaxYoutubeMobile02PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** This placement's creative slot is the 1:1 square format. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
